import toggle from './toggle'

export default {
  'a-lte-aside-toggle': toggle
}
